





































































































import { Component, Vue } from 'vue-property-decorator';
import BaseVue from '@/core/BaseVue';
import GenericEdit from '@/core/Generics/GenericEdit';
import Language from "@/models/language/language.model";
import TipoEvaluacion from '@/models/evaluacion/tipoEvaluacion.model';
import { ParesEvaluadoresTypes } from '@/enums/ParesEvaluadoresTypes';
import BaseSelectComponent from '@/components/base/baseSelect/baseSelect.vue';

@Component({
  components: {
    BaseSelectComponent
  }
})
export default class EvaluationTypeEdit extends GenericEdit<TipoEvaluacion> {
  types = [
    {
      id: ParesEvaluadoresTypes.PERTINENCIA,
      name: 'Pertinencia'
    },
    {
      id: ParesEvaluadoresTypes.CIENTIFICOTECNICO,
      name: 'Científico Técnico'
    },
    {
      id: ParesEvaluadoresTypes.FINANCIERO,
      name: 'Financiero'
    },
  ];

  constructor() {
    super();
    this.controller = "TipoEvaluacion";
    this.model = new TipoEvaluacion();
  }
}
